<template>
  <svg
    width="75"
    height="105"
    viewBox="0 0 75 105"
    fill="none"
    :class="shadow ? 'shadow' : ''"
  >
    <path
      d="M53.1641 0H2.55139C1.14228 0 0 1.22033 0 3.58832V102.47C0 103.113 1.14228 104.333 2.55139 104.333H72.4381C73.8472 104.333 74.9895 103.113 74.9895 102.47V24.1792C74.9895 22.8825 74.8273 22.4652 74.5413 22.1578L54.2488 0.478815C53.9611 0.173268 53.5704 0 53.1641 0Z"
      fill="#F0F1F1"
    />
    <path
      d="M54.0619 0.280151V22.356H74.7259L54.0619 0.280151Z"
      fill="#DBDCDE"
    />
    <path
      d="M72.4381 104.331H2.55139C1.14228 104.331 0 103.111 0 101.606V72.6588H74.9895V101.606C74.9895 103.111 73.8472 104.331 72.4381 104.331Z"
      fill="#91CDA0"
    />
    <path
      d="M24.2055 89.6174L28.6648 98.7373H25.3513L22.561 91.6557H22.3221L19.3173 98.7373H16.0038L20.463 89.6174L15.7178 79.9629H18.9842L22.0832 87.6053H22.3221L25.6844 79.9629H28.9508L24.2055 89.6174Z"
      fill="white"
    />
    <path
      d="M35.8171 79.9692V96.4241H43.9003V98.7418H32.9082V79.9692H35.8171Z"
      fill="white"
    />
    <path
      d="M56.7513 93.5958C56.7513 94.274 56.6205 94.9335 56.3572 95.5707C56.0939 96.2078 55.7259 96.7668 55.2498 97.2512C54.7737 97.7356 54.1842 98.1212 53.4849 98.41C52.7856 98.6988 51.9904 98.8423 51.101 98.8423C50.719 98.8423 50.3266 98.8199 49.9203 98.7789C49.514 98.7379 49.1059 98.6634 48.6926 98.5628C48.2793 98.4603 47.8851 98.3206 47.5119 98.1417C47.1387 97.9629 46.8161 97.7468 46.5458 97.4915L47.0463 95.3005C47.2678 95.4365 47.5503 95.5688 47.8921 95.6955C48.2339 95.8222 48.5862 95.9414 48.9524 96.0513C49.3169 96.1631 49.6831 96.2507 50.0494 96.3196C50.4138 96.3867 50.7557 96.4221 51.0748 96.4221C52.0444 96.4221 52.7873 96.1799 53.3036 95.6955C53.8198 95.2111 54.0779 94.4938 54.0779 93.5436C54.0779 92.9661 53.8948 92.4742 53.5303 92.0662C53.164 91.6582 52.7071 91.2893 52.1595 90.9576C51.6119 90.626 51.019 90.2963 50.3825 89.9646C49.7459 89.633 49.1495 89.2417 48.5949 88.7927C48.0386 88.3437 47.5782 87.8127 47.212 87.2017C46.8457 86.5906 46.6644 85.8267 46.6644 84.91C46.6644 84.0791 46.8074 83.3395 47.0934 82.6948C47.3794 82.0502 47.7648 81.5006 48.2496 81.0516C48.7344 80.6026 49.2995 80.2579 49.943 80.0194C50.5865 79.7809 51.2666 79.6636 51.9816 79.6636C52.7124 79.6636 53.4518 79.7362 54.1982 79.8797C54.9446 80.0232 55.548 80.2579 56.0102 80.5802C55.9142 80.8001 55.8026 81.0423 55.6771 81.3068C55.5498 81.5714 55.4294 81.8154 55.3196 82.0446C55.2079 82.2738 55.112 82.4657 55.0335 82.6184C54.9533 82.7712 54.9062 82.8569 54.8905 82.8737C54.7946 82.8234 54.6882 82.7563 54.5679 82.6706C54.4476 82.5849 54.2767 82.5011 54.0552 82.4154C53.832 82.3297 53.539 82.2719 53.1728 82.2365C52.8065 82.2011 52.3374 82.2104 51.7654 82.2626C51.4463 82.298 51.1463 82.393 50.8585 82.5551C50.5708 82.7172 50.3179 82.9147 50.0947 83.1531C49.8715 83.3916 49.6971 83.658 49.5698 83.9561C49.4425 84.2524 49.3797 84.5393 49.3797 84.8094C49.3797 85.4876 49.5611 86.0354 49.9273 86.4527C50.2918 86.87 50.7452 87.2333 51.2858 87.5482C51.8264 87.8631 52.4141 88.1686 53.0507 88.4648C53.6855 88.7611 54.2784 89.1244 54.8278 89.5473C55.3771 89.9702 55.8323 90.5031 56.1985 91.1384C56.5682 91.7755 56.7513 92.5934 56.7513 93.5958Z"
      fill="white"
    />
    <path
      d="M29.647 29.8041V22.3517H8.71973V29.8041V33.5302V37.2564V40.9826V44.7088V48.435V52.1612V55.8874V63.3398H26.1592H29.647H66.2698V55.8874V52.1612V48.435V44.7088V40.9826V37.2564V29.8041H29.647ZM12.2076 26.0779H26.1592V29.8041H12.2076V26.0779ZM12.2076 33.5302H26.1592V37.2564H12.2076V33.5302ZM12.2076 40.9826H26.1592V44.7088H12.2076V40.9826ZM12.2076 48.435H26.1592V52.1612H12.2076V48.435ZM26.1592 59.6136H12.2076V55.8874H26.1592V59.6136ZM62.7819 59.6136H29.647V55.8874H62.7819V59.6136ZM62.7819 52.1612H29.647V48.435H62.7819V52.1612ZM62.7819 44.7088H29.647V40.9826H62.7819V44.7088ZM29.647 37.2564V33.5302H62.7819V37.2564H29.647Z"
      fill="#91CDA0"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconXls',
    props: {
      shadow: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
